import { forwardRef } from 'react';
import { Tabs, Tab, type TabsProps, type TabProps } from '@mui/material';

/**
 * RwTabs / RwTab — DS in-page LINE tabs (rw-ds.css `.rw-tabs` + MUI-BRIDGE §Tabs).
 *
 * Thin pass-throughs over MUI `Tabs`/`Tab`; the DS look is applied globally in
 * themeOptions (left-aligned auto-width tabs, full-width baseline divider, 2px
 * `--border-neutral-bold` underline on selected, regular→medium weight on select,
 * scroll-on-overflow with no arrow buttons). Selection cue is the underline —
 * colour stays reserved for primary/status.
 *
 * Governance (review, not enforced here): line tabs only — avoid
 * `variant="fullWidth"`/`centered` and `orientation="vertical"` (vertical stacking
 * is the Accordion's job; a segmented control is `RwSegmented`).
 */
export const RwTabs = forwardRef<HTMLDivElement, TabsProps>(function RwTabs(props, ref) {
  return <Tabs ref={ref} {...props} />;
});

export const RwTab = forwardRef<HTMLDivElement, TabProps>(function RwTab(props, ref) {
  return <Tab ref={ref} {...props} />;
});
